import React, { useMemo, useCallback } from 'react'
import Button from 'shared/components/Button'
import { useDispatch, useSelector } from 'react-redux'
import history from 'shared/utils/history'
import { organizationSettingSelector } from 'shared/hocs/withAuth'
import styled from 'styled-components'
import Box from 'shared/components/Box'
import { useBreakpoint } from 'shared/hooks/useBreakpoint'
import SupportDialog from 'pages/Support/components/Dialogs/SupportDialog'
import NotFoundLargeImg from 'assets/images/404_large.png'
import { showDialog, hideDialog } from 'shared/redux/app/reducer'
import { FORMSTACK_LINK } from 'shared/constants/variables'

function NotFound() {
  const dispatch = useDispatch()
  const breakpoint = useBreakpoint()
  const { organization_information } = useSelector(organizationSettingSelector)
  const isShowBigImage = useMemo(() => breakpoint === 'tablet-landscape' || breakpoint === 'desktop', [breakpoint])

  const onClickReportAProblem = useCallback(() => {
    if (organization_information.support_email) {
      dispatch(
        showDialog({
          component: SupportDialog,
          props: {
            icon: null,
            title: `Scoreboard Support`,
            supportSubject: `Scoreboard Support`,
            hasCancel: false,
            onValid: () => {
              dispatch(hideDialog())
            },
          },
        }),
      )
    } else {
      window.open(FORMSTACK_LINK, '_blank', 'noopener,noreferrer')
    }
  }, [organization_information, dispatch, showDialog])

  return (
    <NotFoundContainer className="not-found-container">
      {isShowBigImage && (
        <NotFoundImageSection>
          <img src={NotFoundLargeImg} className="background-img" />
        </NotFoundImageSection>
      )}
      <NotFoundSection className={isShowBigImage ? 'big' : 'small'}>
        <NotFoundSectionContainer>
          <NotFoundSectionTitle>404</NotFoundSectionTitle>
          <NotFoundSectionSubTitle>Sorry Page Not Found</NotFoundSectionSubTitle>
          <NotFoundSectionDescription>
            If you think there&apos;s something broken, please report the problem
          </NotFoundSectionDescription>
          <NotFoundButtonContainer>
            <Button variant="primary" onClick={() => history.push('/login')} size="large">
              Return Home
            </Button>
            <Button variant="outline-primary" onClick={onClickReportAProblem} size="large">
              Report a Problem
            </Button>
          </NotFoundButtonContainer>
        </NotFoundSectionContainer>
      </NotFoundSection>
    </NotFoundContainer>
  )
}

const NotFoundContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  height: 100vh;
`

const NotFoundSection = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  &.big {
    width: 50%;
  }
  &.small {
    width: 100%;
  }
`

const NotFoundSectionContainer = styled(Box)`
  width: 100%;
  margin-left: 20%;
`

const NotFoundSectionTitle = styled(Box)`
  color: ${({ theme }) => theme.colors.main};
  font-weight: bold;
  font-size: 240px;
  line-height: 240px;
`

const NotFoundSectionSubTitle = styled(Box)`
  font-weight: bold;
  font-size: 32px;
  line-height: 32px;
  margin-top: 15px;
`

const NotFoundSectionDescription = styled(Box)`
  color: ${({ theme }) => theme.colors.main};
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  margin-top: 15px;
`

const NotFoundButtonContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  padding: 30px;
  padding-left: 0;

  button {
    min-width: 140px;

    &:first-child {
      margin-right: 2rem;
    }
  }
`

const NotFoundImageSection = styled(Box)`
  display: flex;
  width: 50%;
  .background-img {
    width: 100%;
    height: auto;
  }
`

export default NotFound
